import { Link } from "react-router-dom";
import { Calendar, Package } from "lucide-react";

const HomePage = () => {
  return (
    <div className="min-h-screen">
      {/* Mobile - Full screen image with buttons inside */}
      <div className="lg:hidden relative" style={{ height: '100dvh' }}>
        <img
          src="https://customer-assets-lxgj4vgw.emergentagent.net/job_politica-reservas/artifacts/hl61xd2d_57FD8638-3367-43BF-9A07-A3786A4A18E4.jpeg"
          alt="Casa Ciudadana Zapopan"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-6 left-0 right-0 px-5">
          <div className="flex flex-col gap-3 max-w-xs mx-auto">
            <Link
              to="/reservaciones"
              className="flex items-center justify-center gap-2 bg-[#EA580C]/90 backdrop-blur-sm text-white py-4 px-5 font-bold text-sm uppercase tracking-wider hover:bg-[#EA580C] transition-colors"
              data-testid="home-reservations-btn"
            >
              <Calendar className="w-5 h-5" />
              Reservar Espacio
            </Link>
          </div>
        </div>
      </div>

      {/* Desktop - Full screen image with buttons inside */}
      <div className="hidden lg:block relative" style={{ height: '100vh' }}>
        <img
          src="https://customer-assets-lxgj4vgw.emergentagent.net/job_politica-reservas/artifacts/aiznzzt0_IMG_4494.webp"
          alt="Casa Ciudadana Zapopan"
          className="w-full h-full object-cover"
        />
        <div className="absolute bottom-12 left-0 right-0">
          <div className="flex gap-5 justify-center px-8">
            <Link
              to="/reservaciones"
              className="flex items-center justify-center gap-3 bg-[#EA580C]/90 backdrop-blur-sm text-white py-5 px-10 font-bold text-lg uppercase tracking-wider hover:bg-[#EA580C] transition-all hover:scale-105 rounded-sm"
              data-testid="home-reservations-btn-desktop"
            >
              <Calendar className="w-6 h-6" />
              Reservar Espacio
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
